var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-biography-career",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          closeEdit: _vm.initCurrentData,
          showEdit: _vm.setShowEdit,
          storeEdit: _vm.storeBlock,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "ol",
                    {
                      staticClass: "cw-timeline",
                    },
                    _vm._l(_vm.sortedItems, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "cw-timeline-item",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "cw-timeline-item-icon cw-timeline-item-icon-color-studip-blue",
                            },
                            [
                              item.type === "school"
                                ? _c("studip-icon", {
                                    attrs: {
                                      shape: "doctoral-cap",
                                      role: "clickable",
                                      size: 32,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.type === "experience"
                                ? _c("studip-icon", {
                                    attrs: {
                                      shape: "tools",
                                      role: "clickable",
                                      size: 32,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "cw-timeline-item-content cw-timeline-item-content-color-studip-blue",
                              class: [index % 2 === 0 ? "left" : "right"],
                            },
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(
                                    item.date
                                      ? _vm.getReadableDate(item.date)
                                      : ""
                                  ) +
                                    _vm._s(
                                      item.enddate
                                        ? " - " +
                                            _vm.getReadableDate(item.enddate)
                                        : ""
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "article",
                                [
                                  _c("header", [
                                    _vm._v(
                                      _vm._s(_vm.getItemTypeName(item.type))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  item.type === "school"
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$gettext(
                                                "Bezeichnung der Qualifikation"
                                              )
                                            ) +
                                              ": " +
                                              _vm._s(item.qualification)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$gettext(
                                                "Hauptfächer / Schwerpunkt"
                                              )
                                            ) +
                                              ": " +
                                              _vm._s(item.focus)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$gettext(
                                                "berufliche Fähigkeiten"
                                              )
                                            ) +
                                              ": " +
                                              _vm._s(item.skills)
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.type === "experience"
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$gettext(
                                                "Name des Arbeitgebers"
                                              )
                                            ) +
                                              ": " +
                                              _vm._s(item.employer)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$gettext("Beruf / Funktion")
                                            ) +
                                              ": " +
                                              _vm._s(item.job)
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(item.description))]),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Zeitliche Sortierung")) +
                                "\n                    "
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentSort,
                                    expression: "currentSort",
                                  },
                                ],
                                on: {
                                  change: function change($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.currentSort = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "none",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Keine")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "asc",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Aufsteigend")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "desc",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Absteigend")))]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button add",
                          on: {
                            click: _vm.addItem,
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Ereignis hinzufügen")))]
                      ),
                      _vm._v(" "),
                      _vm.currentItems.length > 0
                        ? _c(
                            "courseware-tabs",
                            {
                              attrs: {
                                setSelected: _vm.setItemTab,
                              },
                              on: {
                                selectTab: function selectTab($event) {
                                  _vm.setItemTab =
                                    parseInt(
                                      $event.name.replace(
                                        _vm.$gettext("Ereignis") + " ",
                                        ""
                                      )
                                    ) - 1
                                },
                              },
                            },
                            _vm._l(_vm.currentItems, function (item, index) {
                              return _c(
                                "courseware-tab",
                                {
                                  key: index,
                                  attrs: {
                                    index: index,
                                    name:
                                      _vm.$gettext("Ereignis") +
                                      " " +
                                      (index + 1).toString(),
                                    selected: index === 0,
                                    canBeEmpty: "",
                                  },
                                },
                                [
                                  _c(
                                    "form",
                                    {
                                      staticClass: "default",
                                      on: {
                                        submit: function submit($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$gettext("Startdatum")
                                              ) +
                                              "\n                            "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.date,
                                                expression: "item.date",
                                              },
                                            ],
                                            attrs: {
                                              type: "date",
                                              required: "",
                                            },
                                            domProps: {
                                              value: item.date,
                                            },
                                            on: {
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "date",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$gettext("Enddatum")) +
                                              "\n                            "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.enddate,
                                                expression: "item.enddate",
                                              },
                                            ],
                                            attrs: {
                                              type: "date",
                                            },
                                            domProps: {
                                              value: item.enddate,
                                            },
                                            on: {
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "enddate",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$gettext("Art")) +
                                            "\n                            "
                                        ),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.type,
                                                expression: "item.type",
                                              },
                                            ],
                                            on: {
                                              change: function change($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  item,
                                                  "type",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "school",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext(
                                                      "Schul- und Berufsbildung"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "experience",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext(
                                                      "Berufserfahrung"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: item.type === "school",
                                              expression:
                                                "item.type === 'school'",
                                            },
                                          ],
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Bezeichnung der Qualifikation"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item.qualification,
                                                  expression:
                                                    "item.qualification",
                                                },
                                              ],
                                              attrs: {
                                                type: "text",
                                              },
                                              domProps: {
                                                value: item.qualification,
                                              },
                                              on: {
                                                input: function input($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    item,
                                                    "qualification",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("label", [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Hauptfächer / Schwerpunkt"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item.focus,
                                                  expression: "item.focus",
                                                },
                                              ],
                                              attrs: {
                                                type: "text",
                                              },
                                              domProps: {
                                                value: item.focus,
                                              },
                                              on: {
                                                input: function input($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    item,
                                                    "focus",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("label", [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "berufliche Fähigkeiten"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item.skills,
                                                  expression: "item.skills",
                                                },
                                              ],
                                              attrs: {
                                                type: "text",
                                              },
                                              domProps: {
                                                value: item.skills,
                                              },
                                              on: {
                                                input: function input($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    item,
                                                    "skills",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: item.type === "experience",
                                              expression:
                                                "item.type === 'experience'",
                                            },
                                          ],
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Name des Arbeitgebers"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item.employer,
                                                  expression: "item.employer",
                                                },
                                              ],
                                              attrs: {
                                                type: "text",
                                              },
                                              domProps: {
                                                value: item.employer,
                                              },
                                              on: {
                                                input: function input($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    item,
                                                    "employer",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("label", [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Beruf / Funktion"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item.job,
                                                  expression: "item.job",
                                                },
                                              ],
                                              attrs: {
                                                type: "text",
                                              },
                                              domProps: {
                                                value: item.job,
                                              },
                                              on: {
                                                input: function input($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    item,
                                                    "job",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext("Beschreibung")
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: item.description,
                                              expression: "item.description",
                                            },
                                          ],
                                          domProps: {
                                            value: item.description,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                item,
                                                "description",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _vm.currentItems.length > 1
                                        ? _c("label", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "button trash",
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.removeItem(index)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$gettext(
                                                        "Ereignis entfernen"
                                                      )
                                                    ) +
                                                    "\n                            "
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _vm._v(
                    _vm._s(_vm.$gettext("Informationen zum Karriere-Block"))
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }